import LinearProgress from '@mui/material/LinearProgress';
import { useTheme } from '@mui/material/styles';

import { brandGradient } from '../../theme';

/// How far into something somebody got, in the two shapes the interface draws it.
///
/// Both are the same statement - "you are here" - and both are drawn in the accent colour,
/// which is what makes a half-watched tile read as half-watched at a glance on any shelf.

/// Across the foot of a tile or a still, inset from its edges as a pill of its own. The dark
/// ground under it is for the picture behind, not for the page.
export function TileProgress({ fraction }: { fraction: number }) {
  return (
    <LinearProgress
      variant="determinate"
      value={fraction * 100}
      sx={{
        position: 'absolute',
        insetInline: 10,
        bottom: 10,
        height: 4,
        zIndex: 1,
        backgroundColor: 'rgba(255,255,255,0.28)',
        backdropFilter: 'blur(8px)',
        boxShadow: '0 2px 10px rgba(0,0,0,0.5)',
        '& .MuiLinearProgress-bar': { backgroundImage: brandGradient },
      }}
    />
  );
}

/// Under the play button on a title's own page, where it is part of the page rather than laid
/// over artwork - so its ground is the page's, darkened or lightened to suit.
export function ResumeProgress({ fraction }: { fraction: number }) {
  const { palette } = useTheme();

  return (
    <LinearProgress
      variant="determinate"
      value={fraction * 100}
      sx={{
        height: 6,
        borderRadius: 3,
        backgroundColor: palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(16,19,25,0.14)',
        '& .MuiLinearProgress-bar': { backgroundImage: brandGradient, borderRadius: 3 },
      }}
    />
  );
}
